import React  from "react";
import "../../styles/layout/footer.scss";

function Footer(){
    return(
    <>
    
    </>
    );
}
export default Footer;